import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pagetemplates/mainpagebody.tsx");
